/**
 * DevExtreme (viz/sankey/constants.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var COLOR_MODE_GRADIENT = exports.COLOR_MODE_GRADIENT = "gradient";
var COLOR_MODE_SOURCE = exports.COLOR_MODE_SOURCE = "source";
var COLOR_MODE_TARGET = exports.COLOR_MODE_TARGET = "target";
var COLOR_MODE_NONE = exports.COLOR_MODE_NONE = "none";



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/viz/sankey/constants.js
// module id = 681
// module chunks = 0